import { getLixianTasks } from '@remote/api/adapter/shell-mqtt'
import { getMagnetDownloadId } from '@remote/api/adapter/helper'
import { IJobInfo, IPoll2queryJobparams, getJobInfo, eraseJob } from '@remote/api/adapter/helper/get-job'
import { IRequestInterceptorParams } from '@remote/api/adapter/index.d'
import {
  IQueryLixianTasksRes,
} from './index.d'
import { store } from '@remote/store'
import iconLink from '@remote/assets/img/magnet.png'

// 查询提交内容的结果
export function querySubmitLixianTasksResult (groupId: string, hander?: (data: IQueryLixianTasksRes[]) => boolean) {
  const loopQueryLixianTasks = (): Promise<[{ ret: number; msg: string }, IQueryLixianTasksRes[]]> => {
    const loop = async (resolve) => {
      const res = await getLixianTasks({ group_id: groupId })
      if (res?.ret === 0) {
        if (res.result.data) {
          if (typeof hander === 'function') {
            const isResolve = hander(res.result.data)
            if (isResolve) {
              resolve([null, res.result.data])
            } else {
              setTimeout(() => {
                loop(resolve)
              }, 3000)
            }
          } else {
            resolve([null, res.result.data])
          }
        } else {
          setTimeout(() => {
            loop(resolve)
          }, 3000)
        }
      } else {
        resolve([res, null])
      }
    }
    return new Promise((resolve) => {
      loop(resolve)
    })
  }
  return loopQueryLixianTasks()
}

// 查询作业类
export class Poll2queryDynamicJob {
  jobsIdMap: { [jobId: string]: IQueryLixianTasksRes }
  constructor (params: IPoll2queryJobparams, reqOptions: IRequestInterceptorParams['options'] = {}) {
    this.jobsIdMap = {}
    this.start(params, reqOptions)
  }
  update (jobsIdMap: { [jobId: string]: IQueryLixianTasksRes }) {
    this.jobsIdMap = jobsIdMap
  }
  // 轮询作业，查询下载状态
  poll2queryJob (params: IPoll2queryJobparams, reqOptions: IRequestInterceptorParams['options'] = {}): Promise<IJobInfo[]> {
    const { device_id, userid, biz, options } = params
    const { timeout = 2 * 60 * 1000, interval = 5 * 1000, leading = false, onCheck } = options
    const that = this
    return new Promise((resolve, reject) => {
      const startTime = Date.now()

      let timer: NodeJS.Timer | null = null
      function check () {
        // jobIds是动态的
        const jobIds = Object.keys(that.jobsIdMap)
        if (!jobIds.length) return
        const targetJobs = jobIds.filter(id => !that.jobsIdMap[id].is_process)
        getJobInfo({
          device_id,
          user_id: userid,
          biz,
          // 过滤torrent process中正在处理的任务
          job_ids: targetJobs,
          page_nums: targetJobs.length,
        }, reqOptions)
          .then((res) => {
            const [err, { data }] = res
            if (!err && data?.list?.length) {
              const { list } = data
              const jobs = Array.isArray(list) ? list : []
              const targetJobs = jobs.filter(t => jobIds?.includes(t.job_id))

              if (targetJobs && targetJobs.length) {
                const [errorMsg, isResolved] = onCheck(targetJobs)
                if (errorMsg) {
                  reject(errorMsg)
                  eraseJob({ biz, device_id, job_id: jobIds }, reqOptions)
                  if (timer) clearInterval(timer)
                }

                if (isResolved) {
                  resolve(targetJobs)
                  eraseJob({ biz, device_id, job_id: jobIds }, reqOptions)
                  if (timer) clearInterval(timer)
                }
              }
            }
          })
      }
      timer = setInterval(() => {
        const now = Date.now()
        if (now - startTime > timeout) {
          reject('链接解析超时')
          if (timer) clearInterval(timer)
        }
        check()
      }, interval)
      if (leading) {
        check()
      }
    })
  }
  start (params: IPoll2queryJobparams, reqOptions: IRequestInterceptorParams['options'] = {}) {
    this.poll2queryJob(params, reqOptions)
  }
}

export function setLocalTast2Store (task: { id: string; url: string; file_name: string }, noCheckUniqueness = false) {
  const taskTemplate = {
    'kind': 'drive/task',
    'id': task.id,
    'type': 'user#download-url',
    'params': {
      'url': task.url,
      'file_id': task.id,
      'spec': '{"local":"local"}',
      'error': '',
      'status': 'running',
    },
    'file_id': '',
    'file_name': task.file_name,
    'file_size': '0',
    'phase': 'PHASE_TYPE_RUNNING',
    'progress': 0,
    'icon_link': iconLink,
    'status': 3,
  }

  if ((store.state.all[task.id] || store.state.tasks.includes(task.id)) && !noCheckUniqueness) return console.error('setLocalTast2Store local task exist')
  store.commit('set', taskTemplate)
  store.commit('update', {
    tasks: [taskTemplate.id, ...store.state.tasks],
  })
}

// 查询当前下载链接对应的下载任务
export function getDownloadIdsMap (magnets: string[], downloadUrls: string[]): Promise<{
  downloadId2UrlMap: { [id: string]: { url: string; name: string } }
  downloadUrl2IdMap: { [url: string]: string }
}> {
  return new Promise(resolve => {
    const downloadId2UrlMap = {}
    const downloadUrl2IdMap = {}
    if (Array.isArray(magnets)) magnets.forEach(item => {
      const id = getMagnetDownloadId(item)
      downloadUrl2IdMap[item] = id
      downloadId2UrlMap[id] = { url: item }
    })

    if (Array.isArray(downloadUrls)) downloadUrls.forEach(item => {
      const id = item
      // getMagnetDownloadId(item)
      downloadUrl2IdMap[item] = id
      downloadId2UrlMap[id] = { url: item }
    })
    resolve({ downloadId2UrlMap, downloadUrl2IdMap })
    // if (Array.isArray(downloadUrls)) {
    //     inspectLixianTasksBatch({ urls: downloadUrls })
    //         .then(res => {
    //             if (res.ret === 0 && res?.result?.data) {
    //                 res.result.data?.forEach(item => {
    //                     downloadUrl2IdMap[item.url] = item.download_id
    //                     downloadId2UrlMap[item.download_id] = item
    //                 })
    //             }
    //             resolve({ downloadId2UrlMap, downloadUrl2IdMap })
    //         })
    //         .catch(() => {
    //             resolve({ downloadId2UrlMap, downloadUrl2IdMap })
    //         })
    // }
  })
}

export function getTaskId (taskId:string):string {
  return taskId.replace('local_', '')
}